import { css } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Mod({ v }) {
  if (!v.showMod) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeMod}>
        <div className="gp-venster" style={{ "width": "min(440px,100%)", "maxHeight": "calc(100vh - 60px)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "16px", "overflowY": "auto", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Modgereedschap
              </div>
            </div>
            <button onClick={v.closeMod} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px" }}>
            <button onClick={v.openBeta} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--lila-diep)" }}>
              {' '}
              {/* Een sleutel: dit scherm zet de deur open naar wat nog in beta staat. */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <circle cx="8" cy="15" r="4.4" />
                <path d="m11 12 8.5-8.5" />
                <path d="m16.5 6.5 2.2 2.2" />
                <path d="m19.2 3.8 2.2 2.2" />
              </svg>
              {"\n          Betatesters\n        "}
            </button>
            <button onClick={v.openBeestje} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--groen-vlak)" }}>
              {' '}
              {/* Een potlood: hier teken je het beestje met de hand. */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M4 20h4L20 8a2.8 2.8 0 0 0-4-4L4 16z" />
                <path d="M14.5 5.5 18.5 9.5" />
              </svg>
              {"\n          Beestje tekenen\n        "}
            </button>
            <button onClick={v.openSeenLog} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--blauw)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <circle cx="12" cy="12" r="9.2" />
                <path d="M12 7.4V12l3.2 2" />
              </svg>
              {"\n          Wie was wanneer online\n        "}
            </button>
            <button onClick={v.openDmPicker} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--lila-diep)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <rect x="2" y="4" width="20" height="16" rx="3" />
                <path d="m3 7 9 6 9-6" />
              </svg>
              {"\n          Bericht sturen\n        "}
            </button>
            <button onClick={v.openLimits} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--blauw)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M3 3v18h18" />
                <path d="M18 17V9" />
                <path d="M13 17v-5" />
                <path d="M8 17v-3" />
              </svg>
              {"\n          Limieten en aantallen\n        "}
            </button>
            <button onClick={v.openDailyPicker} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--geel-vlak)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M12 3.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8L3.5 9.7l5.9-.9z" />
              </svg>
              {"\n          Krabbel van morgen kiezen\n        "}
            </button>
            <button onClick={v.openPollForm} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--geel)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M6 20V10" />
                <path d="M12 20V4" />
                <path d="M18 20v-6" />
              </svg>
              {"\n          Poll aanmaken\n        "}
            </button>
            <button onClick={v.openThemeList} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px", "background": "var(--groen-vlak)" }}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M8 6h13" />
                <path d="M8 12h13" />
                <path d="M8 18h13" />
                <path d="M3 6h.01" />
                <path d="M3 12h.01" />
                <path d="M3 18h.01" />
              </svg>
              {"\n          Alle thema's\n        "}
            </button>
            {v.hasActivePoll ? (<>
              <button onClick={v.endPoll} className="gp-btn" style={{ "width": "100%", "justifyContent": "flex-start", "gap": "11px", "fontSize": "15px", "padding": "13px 15px" }}>
                {' '}
                <Kruis maat={20} />
                {"\n            Huidige poll sluiten\n          "}
              </button>
            </>) : null}
          </div>
          <button onClick={v.closeMod} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
